module.exports = __webpack_public_path__ + "a334e0bf2e27ccfcd8bd5f42485e4638.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1150
// module chunks = 0